(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mavae-faq"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-mv-faq]').forEach(function (list) {
    list.addEventListener('toggle', function (e) {
      if (!e.target.open) return;
      list.querySelectorAll('details[open]').forEach(function (d) { if (d !== e.target) d.open = false; });
    }, true);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mavae-in-use"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-mv-use] .mv-use__play').forEach(function (b) {
    b.addEventListener('click', function () { var card = b.closest('.mv-use__card'), v = card.querySelector('video'); if (!v) return; v.play(); card.classList.add('is-playing'); });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mavae-objection"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-mv-open-faq]'); if (!a) return;
    var d = document.getElementById('mv-faq-' + a.dataset.mvOpenFaq); if (!d) return;
    e.preventDefault(); d.open = true; d.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mavae-review-list"] && !Shopify.designMode) return;
  try {
    (function () {
    function init() {
      document.querySelectorAll('[data-mv-rl]').forEach(function (list) {
        if (list.dataset.open === '1') return;
        var n = parseInt(list.dataset.initial, 10) || 3;
        var items = [].slice.call(list.querySelectorAll('[data-mv-rl-item]'));
        var more = list.querySelector('[data-mv-rl-more]');
        items.forEach(function (it, i) { it.hidden = i >= n; });
        if (more) more.hidden = !(items.length > n);
      });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mv-rl-more] button'); if (!btn) return;
      e.preventDefault();
      var list = btn.closest('[data-mv-rl]'); if (!list) return;
      list.dataset.open = '1';
      list.querySelectorAll('[data-mv-rl-item]').forEach(function (it) { it.hidden = false; });
      btn.closest('[data-mv-rl-more]').hidden = true;
    });
    function start() {
      init();
      var queued = false;
      new MutationObserver(function (m) { if (queued) return; for (var k = 0; k < m.length; k++) { if (m[k].addedNodes.length) { queued = true; requestAnimationFrame(function () { queued = false; init(); }); break; } } }).observe(document.body, { childList: true, subtree: true });
      document.addEventListener('shopify:section:load', init);
    }
    // block scripts run in <head>: document.body does not exist yet, so everything waits for DOMContentLoaded
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mavae-review-slider"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-mv-mini]').forEach(function (w) {
    if (w.dataset.mvInit) return; w.dataset.mvInit = '1';
    var s = w.querySelector('.mv-mini__slides'), n = s.children.length, i = 0, t;
    function go(k) { i = (k + n) % n; s.style.transform = 'translateX(-' + (i * 100) + '%)'; }
    function arm() { clearInterval(t); if (w.dataset.autoplay === 'true' && n > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) t = setInterval(function () { go(i + 1); }, (+w.dataset.interval || 4) * 1000); }
    w.querySelector('.mv-mini__btn--prev').addEventListener('click', function () { go(i - 1); arm(); });
    w.querySelector('.mv-mini__btn--next').addEventListener('click', function () { go(i + 1); arm(); });
    arm();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mavae-sticky-buy-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    var bar = document.querySelector('[data-mv-sticky]'); if (!bar) return;
    var main = document.querySelector('.product-details product-form-component, [id$="__main"] product-form-component');
    var mainId = main && main.querySelector('input[name="id"]');
    var target = document.querySelector('.buy-buttons-block') || main;
    var idInput = bar.querySelector('[data-mv-sticky-id]'), price = bar.querySelector('[data-mv-sticky-price]'), variant = bar.querySelector('[data-mv-sticky-variant]');
    function sync() {
      if (mainId && idInput && mainId.value) idInput.value = mainId.value;
      var p = document.querySelector('.product-details .price'); if (p && price) { var m = p.textContent.match(/[$€£]\s?[\d.,]+/); if (m) price.textContent = m[0]; }
      var picked = [].slice.call(document.querySelectorAll('.product-details variant-picker input:checked + label, .product-details variant-picker [aria-checked="true"], .product-details variant-picker select option:checked')).map(function (e) { return e.textContent.trim(); }).filter(Boolean);
      if (picked.length && variant) variant.textContent = picked.join(' / ');
      if (typeof syncBundle === 'function') syncBundle(); /* Jesse 30-09: a chosen KaChing bundle wins over the single price */
    }
    function check() { if (!target) return; var r = target.getBoundingClientRect(); bar.hidden = !(r.bottom < 0); }
    if ('IntersectionObserver' in window && target) new IntersectionObserver(function () { check(); }, { threshold: 0 }).observe(target);
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('pageshow', function () { check(); sync(); });
    document.addEventListener('change', function (e) { if (main && main.contains(e.target)) setTimeout(sync, 50); });
    bar.addEventListener('submit', sync, true);
    /* Jesse 30-09: the bar presses the product's own add-to-cart button, so a bundle app on the main form
       (KaChing) adds the bundle that is selected there — the bar's own form would add one unit only. */
    function mainButton() { return document.querySelector('.product-details button[name="add"]:not(.mv-sticky__btn)'); }
    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('.mv-sticky__btn'); var mb = mainButton();
      if (!btn || !mb || mb.disabled) return;
      e.preventDefault(); e.stopPropagation(); mb.click();
    }, true);
    function syncBundle() {
      var sel = document.querySelector('.product-details .kaching-bundles__bar--selected, .kaching-bundles__bar--selected'); if (!sel) return;
      var bp = sel.querySelector('.kaching-bundles__bar-price'), bt = sel.querySelector('.kaching-bundles__bar-title');
      if (bp && price) price.textContent = bp.textContent.trim();
      if (bt && variant) variant.textContent = bt.textContent.trim();
    }
    document.addEventListener('change', function () { setTimeout(syncBundle, 60); });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.kaching-bundles')) setTimeout(syncBundle, 60); });
    if ('MutationObserver' in window) { var kq = false; new MutationObserver(function (m) { if (kq) return; for (var k = 0; k < m.length; k++) { if (m[k].addedNodes.length || m[k].attributeName === 'class') { kq = true; requestAnimationFrame(function () { kq = false; syncBundle(); }); break; } } }).observe(document.querySelector('.product-details') || document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] }); }
    window.addEventListener('load', syncBundle);
    check(); sync();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mavae-story-media"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.mv-smedia video').forEach(function(v){ v.muted = true; v.setAttribute('muted',''); var p = v.play(); if (p && p.catch) p.catch(function(){}); });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mavae-story"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.mv-story').forEach(function(root){
    var slides=[].slice.call(root.querySelectorAll('.mv-story__slide')); if(!slides.length) return;
    var dots=root.querySelector('.mv-story__dots'); slides.forEach(function(){dots.appendChild(document.createElement('i'))});
    var i=0,t; function show(n){i=(n+slides.length)%slides.length; slides.forEach(function(s,k){s.classList.toggle('is-active',k===i)}); [].forEach.call(dots.children,function(d,k){d.classList.toggle('is-active',k===i)});}
    function arm(){ if(root.dataset.autoplay!=='true') return; clearInterval(t); t=setInterval(function(){show(i+1)},(+root.dataset.interval||6)*1000); }
    root.querySelector('.mv-story__btn--prev').addEventListener('click',function(){show(i-1);arm()});
    root.querySelector('.mv-story__btn--next').addEventListener('click',function(){show(i+1);arm()});
    show(0); arm();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mavae-ugc-row"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.mv-ugc').forEach(function(root){
    var track=root.querySelector('.mv-ugc__track'); var step=function(){var c=track.querySelector('.mv-ugc__card');return c?c.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap||16):300};
    var p=root.querySelector('.mv-ugc__arrow--prev'),n=root.querySelector('.mv-ugc__arrow--next'); if(p)p.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'})});
    if(n)n.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'})});
  });
  } catch(e) { console.error(e); }
})();

})();
